
import defaultTagData from './default';
import eventTagData from './event';
import hotissueTagData from './hotissue';
import liveTagData from './live';
import passTagData from './pass';
import playzoneTagData from './playzone';
import tvTagData from './tv';


export default function index(urlPathpath, pageSection = '', pageCategory = '') {
  const firstSegment = (urlPathpath || '').split('?')[0].split('/').filter(x => x !== 'm' && !!x)[0];
  let result;

  switch (firstSegment) {
    case 'tv':
      result = tvTagData(pageSection);
      break;
    case 'live':
      result = liveTagData(pageSection);
      break;
    case 'event':
    case 'promotion':
      result = eventTagData;
      break;
    case 'hotissue':
      result = hotissueTagData;
      break;
    case 'pass':
      result = passTagData(pageSection);
      break;
    case 'playzone':
      result = playzoneTagData(pageSection);
      break;
    default:
      result = defaultTagData;
      break;
  }

  return { ...result };
}
